import type { CloudType } from '../../types/external'
import { ListingType } from './listingCardCreation/types'

export enum StorefrontActionTypes {
  SET_TEMPLATES_DATA = 'SET_TEMPLATES_DATA',
  SET_INTEGRATIONS_DATA = 'SET_INTEGRATIONS_DATA',
  CLEAR_INTEGRATIONS_DATA = 'CLEAR_INTEGRATIONS_DATA',
}

export interface Template {
  name?: string
  cloud?: string
  usedAt?: string
  lastUpdateInDays?: string
  id?: string
  integratinId?: string
  type?: ListingType
}
export interface Integrations {
  id: string
  name: string
  createdAt: string
  updatedAt: string
  lastUpdateInDays: string
  type?: ListingType
  cloud: CloudType
  cards?: string[]
}

export interface StorefrontState {
  templates: Template[]
  integrations: Integrations[]
}

export type StorefrontAction =
  | {
      type: StorefrontActionTypes.SET_TEMPLATES_DATA
      payload: Template[]
    }
  | {
      type: StorefrontActionTypes.SET_INTEGRATIONS_DATA
      payload: Integrations[]
    }
  | {
      type: StorefrontActionTypes.CLEAR_INTEGRATIONS_DATA
    }

export const initialStorefrontState: StorefrontState = {
  templates: [],
  integrations: [],
}
